import { ModalWrapper } from "@/components/modals/modal-wrapper";
import { popModal, pushModal } from "@/stores/modal";
import { Button } from "@/toggle-ui-kit/button";

interface UnsavedExitConfirmModalProps {
  /** 저장하지 않고 나갈 때 — 실제 이동은 부른 쪽이 한다 */
  onConfirm: () => void;
}

/** 미저장 변경이 있는 채로 화면을 떠나려 할 때 (Figma 7160:558433) */
export const UnsavedExitConfirmModal = ({
  onConfirm,
}: UnsavedExitConfirmModalProps) => {
  const handleConfirm = () => {
    popModal();
    onConfirm();
  };

  return (
    <ModalWrapper className="flex w-[548px] flex-col gap-0 rounded-[10px] border border-line-normal bg-background-base p-0 shadow-2xl">
      <div className="flex flex-col gap-4 px-6 pb-5 pt-6">
        <h2 className="headline-1-semibold text-label-normal">
          수정 내용이 저장되지 않았습니다.
        </h2>
        <p className="body-2-normal-regular text-label-alternative">
          지금 나가면 수정한 내용이 모두 사라지며, 복구할 수 없습니다.
          <br />
          저장하지 않고 나가시겠습니까?
        </p>
      </div>

      <div className="flex justify-end gap-2 px-6 pb-6">
        <Button
          variant="outlined"
          color="secondary"
          size={36}
          onClick={popModal}
          className="min-w-[90px]"
        >
          계속 편집
        </Button>
        <Button
          variant="solid"
          color="primary"
          size={36}
          onClick={handleConfirm}
          className="min-w-[140px] bg-status-negative"
        >
          저장하지 않고 나가기
        </Button>
      </div>
    </ModalWrapper>
  );
};

/** 가드가 보는 것은 hasUnguardedChanges 뿐이다 — 아래 주석이 그 이유다. */
type ExitGuardSession = {
  /** 이탈 경고 대상. 재조회 중(=서버 저장은 끝난) 변경은 빠져 있다 */
  hasUnguardedChanges: boolean;
  /** 저장 버튼 활성 조건. 재조회 구간에도 true 라 가드 판정에는 쓰면 안 된다 */
  hasUnsavedChanges: boolean;
};

/**
 * 앱 내 이탈(로고 클릭 등) 직전 가드. 미저장 변경이 있으면 팝업으로 확인을 받고,
 * 없으면 바로 내보낸다. 실제 이동은 `leave` 가 한다.
 */
export const guardUnsavedExit = (
  session: ExitGuardSession,
  leave: () => void,
) => {
  if (!session.hasUnguardedChanges) {
    leave();
    return;
  }
  pushModal(UnsavedExitConfirmModal, { onConfirm: leave });
};
